/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminStockItem
 */
export interface OutputAdminStockItem {
    /**
     * 
     * @type {string}
     * @memberof OutputAdminStockItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminStockItem
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminStockItem
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminStockItem
     */
    totalOnPositions?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminStockItem
     */
    type?: string;
}

/**
 * Check if a given object implements the OutputAdminStockItem interface.
 */
export function instanceOfOutputAdminStockItem(value: object): boolean {
    return true;
}

export function OutputAdminStockItemFromJSON(json: any): OutputAdminStockItem {
    return OutputAdminStockItemFromJSONTyped(json, false);
}

export function OutputAdminStockItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminStockItem {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'totalOnPositions': json['totalOnPositions'] == null ? undefined : json['totalOnPositions'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function OutputAdminStockItemToJSON(value?: OutputAdminStockItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'id': value['id'],
        'name': value['name'],
        'totalOnPositions': value['totalOnPositions'],
        'type': value['type'],
    };
}

